import KeenSlider from 'keen-slider';

if (!customElements.get('ia-slider')) {

  class IASlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.currentSlideElement = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressFill = null;
      console.log('IASlider constructor', this);
    }
  
    connectedCallback() {
      // Defer initialization if data-defer-init is set
      if (this.dataset.deferInit === 'true') {
        return;
      }
      this.initializeSlideshow();
    }
  
    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
    }
  
    initializeSlideshow() {
      const carousel = this.querySelector('.ia-slider__slides');
      this.currentSlideElement = this.querySelector('.js-ia-slider-current');
      this.prevButton = this.querySelector('.js-ia-slider-prev');
      this.nextButton = this.querySelector('.js-ia-slider-next');
      this.progressFill = this.querySelector('.ia-slider__progress-fill');

      const loop = this.dataset.loop === 'true';
      const isVertical = this.dataset.direction === 'vertical';

      if (!carousel) return;
  
      this.slider = new KeenSlider(carousel, {
        loop: loop,
        vertical: isVertical,
        slides: {
          perView: this.style.getPropertyValue('--items-desktop'),
          spacing: this.style.getPropertyValue('--spacing-desktop').replace('px', ''),
        },
        breakpoints: {
          '(max-width: 1023px)': {
            slides: {
              perView: this.style.getPropertyValue('--items-mobile'),
              spacing: this.style.getPropertyValue('--spacing-mobile').replace('px', ''),
              origin: this.dataset.centeredMobile === 'true' ? 0.25 : undefined,
            },
          },
        },
        created: (slider) => {
          this.classList.add('is-initialized');
          const firstSlide = this.querySelector('.ia-slider__slide');
          if (firstSlide) {
            firstSlide.classList.add('is-active');
          }
          this.createProgressBar();
          
          // Update progress after slider is created
          setTimeout(() => {
            this.updateProgress();
          }, 50);
        },
        slideChanged: (slider) => {
          this.updateProgress();
        }
      })
  
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.slider.prev();
        });
      }
  
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.slider.next();
        });
      }
  
      this.slider.on('slideChanged', (slide) => {
        const allSlides = this.querySelectorAll('.ia-slider__slide');
        allSlides.forEach(slide => slide.classList.remove('is-active'));
        
        const currentSlide = this.slider.track.details.rel;
        if (allSlides[currentSlide]) {
          allSlides[currentSlide].classList.add('is-active');
        }
        
        if (this.slider?.track?.details?.rel >= 0 && this.currentSlideElement) {
          this.currentSlideElement.textContent = this.slider.track.details.rel + 1;
        }
        
        this.updateProgress();
      });

    }
  
    createProgressBar() {
      if (this.dataset.showProgress !== 'true') return;

      if (this.querySelector('.ia-slider__progress')) return;

      const progressContainer = document.createElement('div');
      progressContainer.className = 'ia-slider__progress ' + this.dataset.colorSchemeUi;

      const progressBar = document.createElement('div');
      progressBar.className = 'ia-slider__progress-bar';

      const progressFill = document.createElement('div');
      progressFill.className = 'ia-slider__progress-fill';

      progressBar.appendChild(progressFill);
      progressContainer.appendChild(progressBar);
      this.appendChild(progressContainer);

      this.progressFill = progressFill;
    }

    updateProgress() {
      const d = this.slider.track.details;
      const totalSlides = d.slides.length;
      const currentSlide = d.rel;
      const minIdx = typeof d.minIdx === 'number' ? d.minIdx : 0;
      const maxIdx = typeof d.maxIdx === 'number' ? d.maxIdx : (totalSlides - 1);
      const steps = Math.max(1, (maxIdx - minIdx + 1));
      const atStart = currentSlide <= minIdx;
      const atEnd   = currentSlide >= maxIdx;
      if (this.dataset.showProgress === 'true' && this.progressFill && this.slider) {
        
        // Only update if we have valid data
        if (totalSlides > 0) {
          // const progress = ((currentSlide + 1) / totalSlides) * 100;
          // this.progressFill.style.width = `${Math.min(progress, 100)}%`;
          
          // Progress by "page" (works with perView > 1)
          const page = currentSlide - minIdx + 1;
          const progress = Math.min(100, (page / steps) * 100);
          this.progressFill.style.width = `${progress}%`;
        }
      }

      if (this.prevButton) {
        this.prevButton.classList.toggle('ia-hidden', atStart);
      }

      if (this.nextButton) {
        this.nextButton.classList.toggle('ia-hidden', atEnd);
      }
    }
  
    next() {
      if (this.slider) {
        this.slider.next();
      }
    }
  
    prev() {
      if (this.slider) {
        this.slider.prev();
      }
    }
  
    goToSlide(index) {
      if (this.slider) {
        this.slider.moveToIdx(index);
      }
    }
  
    destroy() {
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }
  }
  
  
  customElements.define('ia-slider', IASlider); 
}